import api from './api';

export function isNotificationUnread(notif) {
  return Number(notif?.is_read ?? 0) === 0;
}

export async function markNotificationRead(notifId) {
  if (!notifId) return;
  await api.patch(`/notifications/${notifId}/read`);
}

export function dispatchNotificationsRead() {
  window.dispatchEvent(new Event('notificationsRead'));
}
